import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountPage} from 'features/loans/pages/LoanAccountPage/LoanAccountPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/loans/$accountId/',
)({
  component: LoanAccountPage,
});
